import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchGuestRelationship } from '../../../sagas/routines';

const initialState = {
  guestById: {},
  fetched: false,
  fetching: false
};

const fetchGuestRelationshipHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(`guestById.${response.id}`, response, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchGuestRelationshipHandler(fetchGuestRelationship)
});
